var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*global CryptoJS*/
import b64_safe, { safe } from "./b64_safe";
const getUtf8Bytes = str => new Uint8Array([...unescape(encodeURIComponent(str))].map(c => c.charCodeAt(0)));
export default function hmac({ key, msg }) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function* () {
        const encodedMessage = getUtf8Bytes(msg);
        const keyBytes = getUtf8Bytes(key);
        const cryptoKey = yield ((_b = (_a = window === null || window === void 0 ? void 0 : window.crypto) === null || _a === void 0 ? void 0 : _a.subtle) === null || _b === void 0 ? void 0 : _b.importKey('raw', keyBytes, { name: 'HMAC', hash: 'SHA-256' }, true, ["sign", "verify"]));
        const signature = yield ((_d = (_c = window === null || window === void 0 ? void 0 : window.crypto) === null || _c === void 0 ? void 0 : _c.subtle) === null || _d === void 0 ? void 0 : _d.sign("HMAC", cryptoKey, encodedMessage));
        return b64_safe(String.fromCharCode(...new Uint8Array(signature)));
    });
}
